import $ from 'jquery'

// WayPoints
import 'waypoints/lib/jquery.waypoints.min.js'

if ($('.sticky-navbar').length) {
  new Waypoint.Sticky({
    element: $('.sticky-navbar')[0],
    stuckClass: 'js-stuck',
    offset: 58,
  })
}



// WEBPACK FOOTER //
// ./landing/static/landing/js/apps.js